module.exports = __webpack_public_path__ + "static/media/kit_carLineTracking_bg.87c9ce05.png";